import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { API_BASE_URL } from '../constants/apiConstants';

export const baseApi = createApi({
    reducerPath: 'baseApi',
    baseQuery: fetchBaseQuery({
        baseUrl: API_BASE_URL, // Replace with your base URL
        prepareHeaders: (headers) => {
            const authToken = localStorage.getItem('authToken');
            const dpApiKey = window.myConfig?.DPApiKey;

            // Use Bearer token if authenticated
            if (authToken) {
                headers.set('Authorization', `Bearer ${authToken}`);
            }
            // Use X-API-Key for anonymous calls (if DPApiKey is available)
            if (dpApiKey) {
                headers.set('X-API-Key', dpApiKey);
            }
            return headers;
        },
    }),
    tagTypes: ['Submitters'], // Tags for invalidating queries
    endpoints: () => ({}), // Will be extended in specific API files
});

export default baseApi;
